/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import TableComponent from "../../components/TableComponent";
import { GridColDef } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import { formatDubaiDate, formatDubaiTime } from "../../utils/dateTime";

interface NotesType {
  id: string;
  note: string;
  employeeName: string;
  dateTime: string;
}

type OfferTableProps = {
  notesData: NotesType[];
};

const BookingRsvpTable = ({ notesData }: OfferTableProps) => {
  const navigate = useNavigate();

  const label = { inputProps: { "aria-label": "Switch demo" } };

  const columns: GridColDef<(typeof notesData)[number]>[] = [
    {
      field: "Date",
      headerName: "Date",
      flex: 1,
      minWidth: 100,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>{row?.dateTime ? formatDubaiDate(row?.dateTime) : "-"}</p>
          </div>
        );
      },
    },
    {
      field: "Time",
      headerName: "Time",
      flex: 1,
      minWidth: 70,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>{row?.dateTime ? formatDubaiTime(row?.dateTime) : "-"}</p>
          </div>
        );
      },
    },
    {
      field: "EmployeeName",
      headerName: "Employee Name",
      flex: 1,
      minWidth: 160,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>{row?.employeeName || "-"}</p>
          </div>
        );
      },
    },
    {
      field: "Remarks",
      headerName: "Note",
      flex: 1,
      minWidth: 130,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>{row?.note || "-"}</p>
          </div>
        );
      },
    },
  ];
  let hidden = ["fullName"];

  return (
    <>
      <div className="sorting_table cards table_cards">
        <TableComponent columns={columns} rows={notesData} />
      </div>
    </>
  );
};

export default BookingRsvpTable;
